/* eslint-disable indent */
/* eslint-disable comma-dangle */
/* eslint-disable no-trailing-spaces */

type StaticImages = {
    readonly [fileName: string]: {
        uri?: string;
    };
}

const imageStaticSourcesByFileName: StaticImages = {
    'iSWcW2Vu7cTxML8XjhLsex.jpg': { uri: '/images/iSWcW2Vu7cTxML8XjhLsex.jpg' },
'8XxLeuHj6G3tBPgYD7bkSc.png': { uri: '/images/8XxLeuHj6G3tBPgYD7bkSc.png' },
'cPEpopj8U5gqhsuRAPt1eU.png': { uri: '/images/cPEpopj8U5gqhsuRAPt1eU.png' },
'hirfY1PGZ1Kb6btZ6KxYso.png': { uri: '/images/hirfY1PGZ1Kb6btZ6KxYso.png' },
'mqieRRM2VBpapkXohhtwRd.png': { uri: '/images/mqieRRM2VBpapkXohhtwRd.png' },
'vTggHzhnatysxgVxTfgfRW.png': { uri: '/images/vTggHzhnatysxgVxTfgfRW.png' },
'cytt9RBoXxHDH7eYZjYzFr.png': { uri: '/images/cytt9RBoXxHDH7eYZjYzFr.png' },
'mu471KjbHDxUB88GUh3Xkn.png': { uri: '/images/mu471KjbHDxUB88GUh3Xkn.png' },
'b6YWaRV8i3hUtEkvq2To4U.png': { uri: '/images/b6YWaRV8i3hUtEkvq2To4U.png' },
'rTzQuE4L39AbJiQy4yJfzd.png': { uri: '/images/rTzQuE4L39AbJiQy4yJfzd.png' },
'93wu2CSVDJxKboieTSNkMr.png': { uri: '/images/93wu2CSVDJxKboieTSNkMr.png' },
'6wASJhs7UXRaYMpKafrMVn.png': { uri: '/images/6wASJhs7UXRaYMpKafrMVn.png' }
}

export default imageStaticSourcesByFileName
